import React from "react";

interface GemIconProps {
  className?: string;
  withStroke?: boolean;
  strokeClassName?: string;
  size?: number;
}

export default function GemIcon({
  className,
  strokeClassName,
  size = 16,
}: GemIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {strokeClassName && (
        <path
          d="M4.64295 2.90881L4.64258 2.90881L1.7168 5.7998L8.0498 12.7978L14.3832 5.7998L11.4578 2.90881H8.04968H4.64295Z"
          fill="none"
          strokeWidth="4"
          strokeLinejoin="round"
          strokeLinecap="round"
          className={strokeClassName}
        />
      )}

      <path
        d="M5.07808 5.7998H1.7168L4.64295 2.90881L5.07808 5.7998Z"
        fill="#818CF8"
      />
      <path
        d="M8.05005 12.7978L1.7168 5.7998H5.07808L8.05005 12.7978Z"
        fill="#5448EE"
      />
      <path
        d="M8.05009 12.7978L5.07812 5.7998H11.0222L8.05009 12.7978Z"
        fill="#818CF8"
      />
      <path
        d="M11.0222 5.7998H5.07812L8.05009 2.90881L11.0222 5.7998Z"
        fill="#E0E7FF"
      />
      <path
        d="M14.3837 5.7998H11.0225L11.4578 2.90881L14.3837 5.7998Z"
        fill="#818CF8"
      />
      <path
        d="M14.3832 5.7998L8.0498 12.7978L11.0219 5.7998H14.3832Z"
        fill="#5448EE"
      />
      <path
        d="M8.04968 2.90881L5.07771 5.7998L4.64258 2.90881H8.04968Z"
        fill="#A5B4FC"
      />
      <path
        d="M11.4572 2.90881L11.0219 5.7998L8.0498 2.90881H11.4572Z"
        fill="#A5B4FC"
      />
    </svg>
  );
}
